/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteIdleTimeInput = {
    id: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteIdleTimeMutationVariables = {
    input: DeleteIdleTimeInput;
};
export type deleteIdleTimeMutationResponse = {
    readonly deleteIdleTime: {
        readonly deletedIdleTimeId: string | null;
    } | null;
};
export type deleteIdleTimeMutation = {
    readonly response: deleteIdleTimeMutationResponse;
    readonly variables: deleteIdleTimeMutationVariables;
};



/*
mutation deleteIdleTimeMutation(
  $input: DeleteIdleTimeInput!
) {
  deleteIdleTime(input: $input) {
    deletedIdleTimeId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteIdleTimeInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIdleTimePayload",
    "kind": "LinkedField",
    "name": "deleteIdleTime",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedIdleTimeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteIdleTimeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteIdleTimeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteIdleTimeMutation",
    "operationKind": "mutation",
    "text": "mutation deleteIdleTimeMutation(\n  $input: DeleteIdleTimeInput!\n) {\n  deleteIdleTime(input: $input) {\n    deletedIdleTimeId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c64e28d1407937f0a1639e7765fedc79';
export default node;
